const Builder = require('../BuilderBase');
const TextColumn = require('../listColumns/TextColumn');

module.exports = class SensorReadList extends Builder {
    constructor(title, properties) {
        super('formElement_MultiPickerSensorGrid', title, properties);
    }

    text(title, properties) {
        const textColumn = new TextColumn(title, properties);
        this.addChildBlock(textColumn, 'columns');
        return textColumn;
    }
};
